// extracted by mini-css-extract-plugin
export default {"wrapperClassName":"styles-module__wrapperClassName__src-labstep-web-core-ChemDraw-ReactionSvg-_feQNn"};